import { canChangeStatus } from '../../components/jobs/statusTransitions';

/**
 * The jobs a status change applies to, and which of them actually need updating.
 * - From Order Preview: exactly the previewed job, whether or not rows are ticked in the list or the job is on the
 *   loaded page (Preview itself skips unchanged statuses and rejected jobs).
 * - From the Orders list: the ticked rows (or the given job), limited to loaded jobs the status map lets this user move
 *   to the target (SC-QA-127; a rejected job moves nowhere) and that aren't already in it.
 */
export const getStatusChangeTargets = ({ jobIds, status, isPreviewClick, selectedJobs, jobs, isSuperAdmin }) => {
    const jobIdsArray = Array.isArray(jobIds) ? jobIds : [jobIds];

    if (isPreviewClick) {
        const previewed = jobIdsArray.map(id => ({ id }));
        return { selectedJobsData: previewed, jobsToUpdate: previewed };
    }

    const selectedJobsData = (selectedJobs.length ? selectedJobs.map(job => job.id) : jobIdsArray)
        .map(id => jobs.find(job => job.id === id))
        .filter(Boolean);

    const jobsToUpdate = selectedJobsData.filter(
        job => job.status.name !== status.name && canChangeStatus(job.status.name, status.name, isSuperAdmin)
    );

    return { selectedJobsData, jobsToUpdate };
};
